import React, { useState } from 'react';

export default function Contact() {
  const [result, setResult] = useState("");
  const [showForm, setShowForm] = useState(true);

  const onSubmit = async (event) => {
    event.preventDefault();
    setResult("Sending....");
    const formData = new FormData(event.target);

    formData.append("access_key", "3406eb8c-1428-4908-9a5a-1afd3617e489");
    

    const response = await fetch("https://api.web3forms.com/submit", {
      method: "POST",
      body: formData
    });

    const data = await response.json();

    if (data.success) {
      setResult("Form Submitted Successfully");
      event.target.reset();
      setShowForm(false);
    } else {
      console.log("Error", data);
      setResult(data.message);
    }
  };

  return (
    <section className="contact" id='contact'>
      <h2>Get In Touch</h2>
      <p>Fill out the form below and I'll get back to you as soon as possible.</p>

      {showForm && (
        <form onSubmit={onSubmit}>
          <input type="text" name="name" placeholder='Name' required/>
          <input type="tel" name="phone" placeholder='Phone' required/>
          <input type="email" name="email" placeholder='Email Addresss' required/>
          <textarea name="message" placeholder='How can I help you?' required></textarea>

          <button type="submit">Submit</button>
        </form>
      )}
      <span>{result}</span>
    </section>
  )
}
